import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setMicroservices } from 'src/redux/microservices/actions'
import { setDefinitions } from 'src/redux/definitions/definitions.actions'
import { setFlowDefinitions } from 'src/redux/editor/editor.actions'
import { setAPI } from 'src/redux/api/api.actions'
import parser from 'src/parser/parser'

const useLocalSwaggerFiles = (): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    const { microservices, paths, definitions } = parser(window._env_.API_URL)

    const { swaggerDefinitions, ...customizedDefinitions } = definitions

    dispatch(setAPI(paths))
    dispatch(setDefinitions(customizedDefinitions))
    dispatch(setFlowDefinitions(swaggerDefinitions))
    dispatch(setMicroservices(microservices))
  }, [dispatch])
}

export default useLocalSwaggerFiles
